export default {
  methods: {
    getIndex(arr, id) {
      return arr.findIndex(el => el.id === id)
    },
  }
}
